import { Component, Input, OnInit } from '@angular/core'

import { Picture } from '../../models/picture.model'

import * as PhotoSwipe from 'photoswipe'
import * as PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js'

@Component({
  selector: 'ld-pictures-viewer',
  template: require('./pictures-viewer.component.html'),
  styles: [require('./pictures-viewer.component.css')]
})
export class PicturesViewerComponent implements OnInit {
  @Input('editable') editable = false
  @Input('pictures') pictures: Picture[] = []
  private pswpElement
  private pswItems = []

  async ngOnInit () {
    for (let i = 0; i < this.pictures.length; i++) {
      const data = await this.pictures[i].asGalleryObject()
      this.pswItems.push(data)
    }

    this.pswpElement = document.querySelectorAll('.pswp')[0]
  }

  removePicture (index) {
    this.pictures.splice(index, 1)
  }

  showGallery (index = 0) {
    if (this.pswItems.length === 0) return

    // define options (if needed)
    const options = {
      index: index
    }

    // Initializes and opens PhotoSwipe
    const gallery = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.pswItems, options)
    gallery.init()
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/pictures-viewer/pictures-viewer.component.ts